import apiClient from "./apiClient";

/* CREATE RAZORPAY ORDER */
export const createPaymentOrder = async (applicationId) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("No token found");

    const response = await apiClient.post(
      `ServiceApplication/${applicationId}/create-payment-order`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;

  } catch (error) {
    console.error("Create payment order failed:", error);

    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Server error:", error.response.data);
    } else if (error.request) {
      console.log("No response received – network/cors issue?", error.request);
    } else {
      console.log("Axios setup error:", error.message);
    }

    throw error;
  }
};


/* VERIFY PAYMENT */
export const verifyPayment = async (payload) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("No token found");

    const response = await apiClient.post(
      `ServiceApplication/verify-payment`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;

  } catch (error) {
    console.error("Payment verification failed:", error);

    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Server error:", error.response.data);
    } else if (error.request) {
      console.log("No response received – network/cors issue?", error.request);
    } else {
      console.log("Axios setup error:", error.message);
    }

    throw error;
  }
};